<template>
    <flash-message ref="flash" @close="handleClose" :seconds-to-display="6">
        <template #body>
            <div v-if="error">
                Error adding to Custom Quotes
            </div>
            <div class="text-center" v-else>
                <div>
                    Success! {{ data.symbol }} has been added to your Custom Quotes
                </div>
                <div>
                    <a class="text-xs" :href="getLink()">
                        Go to Custom Quotes
                    </a>
                </div>
            </div>
        </template>
    </flash-message>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    error: Boolean,
    data: Object
});

const emit = defineEmits(['close']);

const flash = ref(null);

const getLink = () => {
    return window.route('my-folder.custom-quotes.index');
};

const handleClose = () => {
    emit('close');
};

onMounted(() => {
    if (props.error) {
        flash.value.error();
    } else {
        flash.value.display();
    }
});
</script>
